"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCardRecognizerExercise = void 0;
const react_redux_1 = require("react-redux");
const helpers_1 = require("@app/helpers");
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const usePrepareExercoseData_1 = require("@app/routes/SpeechDevelopment/hooks/usePrepareExercoseData");
const useRecognizer_1 = require("@app/routes/SpeechDevelopment/hooks/useRecognizer");
const useIsProcessing_1 = require("@app/routes/SpeechDevelopment/hooks/useIsProcessing");
const CardsRecognizerExerciseHandler_1 = require("@app/routes/SpeechDevelopment/handlers/CardsRecognizerExerciseHandler");
const react_1 = require("react");
const useRecognizerSubscription_1 = require("@app/routes/SpeechDevelopment/hooks/useRecognizerSubscription");
const timer_1 = require("@app/routes/SpeechDevelopment/exersices/Disinhibition/timer");
const useCardRecognizerExercise = ({ exerciseParams, addCoin }) => {
    var _a, _b;
    const dispatch = (0, react_redux_1.useDispatch)();
    const langId = (0, helpers_1.getCurrentLanguage)();
    const answers = (0, exercise_js_1.useSelectAnswers)();
    const currentCardIndex = (0, exercise_js_1.useSelectCurrentIndex)();
    const isStarted = (0, exercise_js_1.useSelectIsStarted)();
    const store = (0, react_redux_1.useSelector)((store) => store);
    const { wordList } = (0, usePrepareExercoseData_1.usePrepareExerciseData)((_a = exerciseParams === null || exerciseParams === void 0 ? void 0 : exerciseParams.text) === null || _a === void 0 ? void 0 : _a.offers);
    const { stopRecognition, startRecognition, isRecognizing, isLoading } = (0, useRecognizer_1.useRecognizer)(wordList);
    const userRightAnswer = (0, exercise_js_1.useSelectUserRightAnswer)();
    const { isProcessing, setIsProcessing, canLeaf } = (0, useIsProcessing_1.useIsProcessing)();
    const exHandler = new CardsRecognizerExerciseHandler_1.CardsRecognizerExerciseHandler({
        store,
        dispatch,
        setIsProcessing,
        exerciseParams,
        langId,
        addCoin: () => __awaiter(void 0, void 0, void 0, function* () { return addCoin(3, 5); }),
    });
    const handleAnswer = (0, react_1.useCallback)((event) => __awaiter(void 0, void 0, void 0, function* () {
        if (isProcessing.current)
            return;
        setIsProcessing(true);
        yield exHandler.handleRecognizeEvent(event);
        setIsProcessing(false);
    }), [exHandler]);
    const handleStart = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        if (!isStarted) {
            dispatch((0, exercise_js_1.setIsStarted)(true));
            exHandler.initInfoRep((_c = exHandler.current) === null || _c === void 0 ? void 0 : _c.id);
        }
        yield startRecognition();
    });
    const handlePause = () => {
        exHandler.pause();
        stopRecognition();
    };
    const handleNext = () => {
        exHandler.nextCard();
    };
    const handlePrev = () => {
        exHandler.previousCard();
    };
    const handleEndExercise = () => {
        exHandler.stopExercise();
        stopRecognition();
    };
    (0, useRecognizerSubscription_1.useRecognizerSubscription)(handleAnswer);
    (0, react_1.useEffect)(() => {
        const handleCurrentCard = () => __awaiter(void 0, void 0, void 0, function* () {
            yield exHandler.playCurrentQuestion();
            (0, timer_1.startTimer)(() => __awaiter(void 0, void 0, void 0, function* () {
                setIsProcessing(true);
                yield exHandler.handleTimerOut();
                setIsProcessing(false);
            }));
        });
        if (isRecognizing)
            handleCurrentCard();
    }, [currentCardIndex, isRecognizing]);
    const answersFrameArray = exHandler.data.map(({ id }) => ({ isCorrect: false, id }));
    answersFrameArray.splice(0, answers.length, ...answers);
    const isPaused = isRecognizing && isRecognizing;
    return {
        isPaused,
        isRecognizing,
        isLoading,
        isStarted,
        canLeaf,
        handlePause,
        handleNext,
        handlePrev,
        handleEndExercise,
        handleStart,
        exHandler,
        answersFrameArray,
        currentCardIndex,
        card: Object.assign(Object.assign({}, exHandler.current), { isCorrect: (_b = answers[currentCardIndex]) === null || _b === void 0 ? void 0 : _b.isCorrect, userRightAnswer: userRightAnswer ? exHandler.extractRightAnswer(userRightAnswer) : null }),
    };
};
exports.useCardRecognizerExercise = useCardRecognizerExercise;
